<app-dialog
  [title]="data.title"
  [actions]="actions"
  (action)="close($event)"
  (close)="close()"
>
  <div class="dialog-container pt-3">
    <div class="item">
      <div class="item_group">
        <span class="item_label">WH ID:</span>
        <span class="item_value">{{shipment?.destinationId}}</span>
      </div>
      <div class="item_group">
        <span class="item_label">SKUs:</span>
        <span class="item_value">{{shipment?.skus?.length}}</span>
      </div>
      <div class="item_group">
        <span class="item_label">Qty:</span>
        <span class="item_value">{{shipment?.qty || shipment?.Qty}}</span>
      </div>
      <div class="item_group">
        <span class="item_label">State:</span>
        <span class="item_value">{{shipment?.shipTo}}</span>
      </div>
      <div class="item_group" *ngIf="shipment?.pctMatch?.pctMatch">
        <span class="item_label">Match Score:</span>
        <span class="item_value">{{round(shipment?.pctMatch?.pctMatch)}}</span>
      </div>
      <div class="item_group">
        <span class="item_label">Distance:</span>
        <span class="item_value">{{shipment?.millage | number: '1.0-0'}} mi</span>
      </div>
      <div class="item_group">
        <span class="item_label">Shipment Name:</span>
        <span class="item_value">{{shipment?.shipmentName}}</span>
      </div>
    </div>
    <div class="shipment-warning mt-2">Note: 'As per amazon policy, all corresponding proposals must be created and used'</div>
  </div>
</app-dialog> 


